import { Link } from 'react-router-dom';
import { categories } from '@/mocks/gossip';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-2 font-heading">
            Categories
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading">
            吃瓜<span className="text-accent-500">分类</span>导航
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            按分类快速找到你最想吃的瓜，明星塌房、网红黑料、反差视频一网打尽
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-2xl bg-background-50 hover:bg-background-200/50 transition-all cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl mb-3 transition-colors ${
                  idx % 3 === 0
                    ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-200'
                    : idx % 3 === 1
                    ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-200'
                    : 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-200'
                }`}
              >
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 line-clamp-1">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-10 md:mt-12 rounded-2xl overflow-hidden relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Link
              to="/category/star-collapse"
              className="md:col-span-2 row-span-2 relative rounded-2xl overflow-hidden aspect-[16/10] md:aspect-auto group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20an%20empty%20stage%20with%20a%20fallen%20microphone%2C%20dark%20theater%20background%2C%20warm%20golden%20light%20from%20above%2C%20symbolic%20representation%20of%20scandal%20and%20downfall%2C%20cinematic%20composition%2C%20high%20drama%20lighting&width=800&height=500&seq=gossip-cat-feat-01&orientation=landscape"
                alt="明星塌房"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="text-lg md:text-xl font-bold text-background-50 font-heading">
                  明星塌房专区
                </span>
                <p className="text-xs md:text-sm text-background-50/70 mt-1">
                  顶流翻车 · 隐婚曝光 · 偷税漏税
                </p>
              </div>
            </Link>

            <Link
              to="/category/influencer-dirt"
              className="relative rounded-2xl overflow-hidden aspect-[16/9] md:aspect-auto group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20social%20media%20live%20stream%20interface%20with%20dramatic%20expressions%2C%20warm%20ring%20light%20glow%2C%20modern%20bedroom%20setup%2C%20influencer%20aesthetic%2C%20soft%20pink%20and%20golden%20tones&width=600&height=400&seq=gossip-cat-feat-02&orientation=landscape"
                alt="网红黑料"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="text-base md:text-lg font-bold text-background-50 font-heading">
                  网红黑料
                </span>
              </div>
            </Link>

            <Link
              to="/category/contrast-video"
              className="relative rounded-2xl overflow-hidden aspect-[16/9] md:aspect-auto group cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20showing%20contrast%20between%20public%20and%20private%20personas%2C%20warm%20vs%20cold%20lighting%2C%20modern%20minimal%20composition%2C%20artistic%20duality%20theme%2C%20soft%20gradient%20background&width=600&height=400&seq=gossip-cat-feat-03&orientation=landscape"
                alt="反差视频"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="text-base md:text-lg font-bold text-background-50 font-heading">
                  反差视频
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}